(function () {
    'use strict';
    angular.module('app').controller('clearextracteddata', clearextracteddata);
    //2018 SP1 Refactor: 2018/0828 - GT
    //Inject extractionservice
    clearextracteddata.$inject = ['$location', '$scope', '$rootScope', '$mdDialog', 'records', 'command', 'loginService', 'selectionCommandService', 'zcs', 'gridDataService','extractionservice'];
    function clearextracteddata($location, scope, $rootScope, $mdDialog, records, command, loginService, selectionCommandService, zcs, gridDataService, extractionservice) {

        // =====================================
        // On Load.
        // =====================================

        // Initialize.
        scope.xyz = { bFields: true, bExtendedRecords: true, bRelationships: true, bThumbnail: true, bFTS: true, bExtractionState: true };
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        // scope
        scope.slx = records;

        // dialog config
        scope.heading = loginService.resourceStrings["TITLE_CLEAR_EXTRACTED_DATA"]; // "Clear Extracted Data";
        scope.fieldsLabel = loginService.resourceStrings["FIELDS"]; // "Fields";
        scope.extendedRecordsLabel = loginService.resourceStrings["EXTENDED_RECORDS"]; // "Extended Records";
        scope.relationshipsLabel = loginService.resourceStrings["RELATIONSHIPS"]; // "Relationships";
        scope.thumbnailLabel = loginService.resourceStrings["THUMBNAIL"]; // "Thumbnail";
        scope.ftsLabel = loginService.resourceStrings["FULL_TEXT_DATA"]; // "Full Text Data";
        scope.extractionStateLabel = loginService.resourceStrings["EXTRACTION_STATE"]; // "ExtractionState";
        scope.OK = loginService.resourceStrings["OK"]; // "OK";
        scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";

        scope.DoWork = function () {
            angular.forEach(scope.slx.list, function (item) {
                zcs.GetMappedFields(item.filename).then(function (response) {
                    var fields = response;
                    // Execute.
                    //2018 SP1 Refactor: 20180828 - GT
                    //changed qualifying service from selectionCommandService to extractionservice
                    extractionservice.clearExtractedData(
                        item.tableNumber, item.fileId, item.majRev, item.minRev,
                        scope.xyz.bFields, scope.xyz.bExtendedRecords, scope.xyz.bRelationships, scope.xyz.bThumbnail, scope.xyz.bFTS, scope.xyz.bExtractionState, fields).then(function (response) {
                            // Close dialog.
                            $mdDialog.hide();
                            scope.xyz.processing = false;

                            gridDataService.updateGridRecords(scope.slx.list); // 2018-02-05

                        }, function (response) {
                            selectionCommandService.ShowEx(response); scope.xyz.processing = false;
                        });

                }, function (response) {
                    scope.xyz.processing = false;
                });
            });
        };

        scope.onClearExtractedDataDialogOK = function () {
            scope.xyz.processing = true;

            if (zcs.bAcsInitPlugInsDone) {
                scope.DoWork();
            }
            else {
                //2018 SP1 Refactor: 20180828 - GT
                //changed qualifying service from selectionCommandService to extractionservice
                extractionservice.getPluginDefinitions().then(function (data) {
                    zcs.AcsInitPlugIns(data).then(function () {
                        scope.DoWork();
                    });
                }, function (response) {
                    selectionCommandService.ShowEx(response); scope.xyz.processing = false;
                });
            }
        };

        scope.onClearExtractedDataDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

    }
})();
